import React from "react";
import "./Section.css";

const Section = ({ type, image, alt, title, text, children }) => (
  <section className={`section ${type}`}>
    {image && <img src={image} alt={alt} className="section-image" />}
    <div className="section-content">
      <h2 className="section-title">{title}</h2>
      {text && <p className="section-text">{text}</p>}
      <div className="section-children">{children}</div>
    </div>
  </section>
);

export default Section;
